<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import CustomerProfile from "./customer-profile";
// import CustomerOrder from "./customer-order";
import { customerService, orderService } from "../../services";
import { debounce, order_statuses } from "../../Helper/helper";
import DateRangePicker from "vue2-daterange-picker";
import OrderList from "../orders/order_tabs/order-list";
import pagination from "laravel-vue-pagination";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import DriverOrder from "../../views/driver/pages/driver-order";
import ChangePassword from "./change-password";
import IndividualPrices from "./individual-prices";
import TabsView from "./customer_tabs/tabs";
/**
 * Products-order component
 */
export default {
  // props: ["user_id"],
  components: {
    Layout,
    PageHeader,
    CustomerProfile,
    OrderList,
    DateRangePicker,
    pagination,
    DriverOrder,
    ChangePassword,
    TabsView,
    IndividualPrices,
  },
  data() {
    return {
      customers: [],
      statuses: order_statuses,
      loading: true,
      debounce,
      orders: {},
      user_id: "",
      tab: "",
      paginations: {},
      limit: 2,
      DeliveredAdditionalColumns: [
        {
          key: "driver_name",
          label: this.trans.get("__JSON__.DriverName"),
          sortable: false,
        },
      ],
      // OrderStatusColumns: [
      //   {
      //     key: "delivery_type",
      //     label: this.trans.get("__JSON__.Order Type"),
      //     sortable: true,
      //   },
      // ],
    };
  },
  mounted() {
    this.getCustomerProfile();
  },
  methods: {
    getCustomerProfile() {
      customerService
        .getCustomerProfile({
          user_id: this.$route.params.user_id,
        })
        .then((response) => {
          this.customers = response.data.result;
          this.user_id = this.$route.params.user_id;
        });
    },

    getCustomerList(page) {
      customerService
        .getCustomerList({
          user_id: this.$route.params.user_id,
          order_status: this.tab,
          page: page && page > 0 ? page : 1,
        })
        .then((response) => {
          // console.log(response.data.result)
          this.orders = response.data.result;
          this.paginations = response.data.result;
          this.loading = false;
        });
    },

    onTabChanged(tabIndex) {
      var tab = [
        "Profile",
        "Delivered",
        "Cancelled",
        "Pending",
        "PickedUp",
        "ChangePassword",
        "IndividualPrices",
      ];
      this.tab = tab[tabIndex];
      if (tabIndex !== 0 && tabIndex !== 5) {
        this.getCustomerList();
      }
    },
  },
  filters: {
    date(val) {
      return val ? val.toLocaleString() : "";
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
            icon-main-page
          "
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-primary
                  text-primary
                  font-size-18
                "
              >
                <i class="bx bx-user-circle"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">
                {{ customers.user_name }} {{ customers.last_name }}
              </h4>
              <p>
                <router-link :to="{ name: 'customer-list' }">{{
                  trans.get("__JSON__.Customer")
                }}</router-link>
                > {{ customers.user_name }} {{ customers.last_name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <b-tabs
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
              lazy
              @activate-tab="onTabChanged"
            >
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Profile")
                  }}</span>
                </template>
                <CustomerProfile />
              </b-tab>
              <b-tab :button-id="statuses.delivered">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-clock"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Delivered")
                  }}</span>
                </template>
                <!-- code now -->
                <TabsView
                  :orders="orders"
                  :loading="loading"
                  :customer_id="$route.params.user_id"
                  :status="statuses.delivered"
                  :extra-columns="DeliveredAdditionalColumns"
                />
              </b-tab>
              <b-tab :button-id="statuses.cancelled">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-times-circle"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Cancelled")
                  }}</span>
                </template>
                <!-- code now -->
                <TabsView
                  :orders="orders"
                  :loading="loading"
                  :customer_id="$route.params.user_id"
                  :status="statuses.delivered"
                />
              </b-tab>

              <b-tab :button-id="statuses.cancelled">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-times-circle"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Pending")
                  }}</span>
                </template>
                <!-- code now -->
                <TabsView
                  :orders="orders"
                  :loading="loading"
                  :customer_id="$route.params.user_id"
                  :status="statuses.delivered"
                />
              </b-tab>

              <b-tab :button-id="statuses.cancelled">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-times-circle"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Picked up")
                  }}</span>
                </template>
                <!-- code now -->
                <TabsView
                  :orders="orders"
                  :loading="loading"
                  :customer_id="$route.params.user_id"
                  :status="statuses.delivered"
                />
              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-lock"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Change Password")
                  }}</span>
                </template>
                <ChangePassword v-if="!!customers" :cust_data="customers" />
              </b-tab>

              <b-tab v-if="customers.user_role === 'Business'">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-lock"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{
                    trans.get("__JSON__.Individual Prices")
                  }}</span>
                </template>
                <IndividualPrices v-if="!!customers" :cust_data="customers"/>
              </b-tab>
            </b-tabs>
            <div
              class="row col-sm-5 offset-sm-7"
              v-if="tab !== 'Profile' && tab !== 'ChangePassword' && tab !== 'IndividualPrices'"
            >
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <pagination
                      :data="paginations"
                      :limit="limit"
                      @pagination-change-page="getCustomerList"
                    ></pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
